export const SHOW = 'consigaz_web/toast/SHOW'
export const DISMISS = 'consigaz_web/toast/DISMISS'